import * as React from 'react';
import { useParams } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';

import { GeneralTab } from '&/features/settings/carriers/components/general-tab';
import { useCarrier } from '&/features/settings/carriers/hooks';

// ─── Page ─────────────────────────────────────────────────────────────────────

function CarrierGeneralPage(): React.JSX.Element | null {
  const { carrierId } = useParams({ from: '/_authenticated/settings_/carriers/$carrierId/' });
  const { data: carrier } = useCarrier(carrierId);

  if (!carrier) {
    return null;
  }

  return (
    <div className="max-w-3xl">
      <GeneralTab carrier={carrier} />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/settings_/carriers/$carrierId/')({
  component: CarrierGeneralPage,
});
